import ProtectedRoute from "routes/ProtectedRoute";
import { protectedRouteLoader } from "routes/loaders/protectedRouteLoader";

export const pagesRoute = [
  {
    path: "page",
    loader: protectedRouteLoader,
    lazy: async () => {
      const [layoutMod, errorMod] = await Promise.all([
        import("components/UI/AdminLayout"),
        import("views/ErrorPage"),
      ]);

      const AdminLayout = layoutMod.default;
      const ErrorPage = errorMod.default;

      return {
        Component: () => (
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        ),
        ErrorBoundary: ErrorPage,
      };
    },
    children: [
      {
        path: "projector",
        lazy: async () => {
          const mod = await import(
            "views/Admin/Settings/NavSetting/projector-setting"
          );
          const Page = mod.ProjectorSetting;
          return { Component: Page };
        },
      },
      {
        path: "organizer",
        lazy: async () => {
          const mod = await import(
            "views/Admin/Settings/NavSetting/organiser-page"
          );
          const Page = mod.OrganiserSettingPage;
          return { Component: Page };
        },
      },
      {
        path: "speaker",
        lazy: async () => {
          const mod = await import(
            "views/Admin/Settings/NavSetting/speaker-page"
          );
          const Page = mod.SpeakerSettingPage;
          return { Component: Page };
        },
      },
    ],
  },
];
